import React from 'react'

export default function CrossWithoutCircle(
  props: React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      width={21}
      height={21}
      fill='currentColor'
      viewBox='0 0 21 21'
      {...props}
    >
      <path d='M20.7096 2.34824L18.6534 0.291992L10.5013 8.44408L2.34922 0.291992L0.292969 2.34824L8.44505 10.5003L0.292969 18.6524L2.34922 20.7087L10.5013 12.5566L18.6534 20.7087L20.7096 18.6524L12.5576 10.5003L20.7096 2.34824Z' />
    </svg>
  )
}
